import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { FormControl, TextField } from "@material-ui/core";
import { useDispatch } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { setStageReview } from "../../redux/actions/leadSourceActions";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  withStyles,
  TableContainer,
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from "../../utils/index";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  bordercolors: {
    border: "1px solid #eee5e5",
    backgroundColor: "#1C375D",
    color: 'white',
    textAlign: "center",
    fontWeight:'bold',
  },
  table: {
    minWidth: 700,
  },
  root: {
    width: "100%",
  },
  title: {
    fontSize: 14,
  },
  customTableContainer: {
    overflowX: "initial",
  },
  pos: {
    marginBottom: 12,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginpivotRight: theme.spacing(1),
    width: 200,
  },
  table: {
    width: "fit-content",
  },
  csv: {
    display: "flex",
    alignItems: "center",
    marginBottom: 20,
  },
  report: {
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  leadSearchButton: {
    backgroundColor: "#FDB913",
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
    "&:hover": { backgroundColor: "#14419c", color: "white" },
  },
  leadClearButton: {
    backgroundColor: "#f7b7b7", // light red background
    color: "#151921",
    padding: "1",
    marginRight: "0.5em",
    borderRadius: "20px",
    width: "20%",
  },
  submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#1C375D",
    color: '#FFF2EB',
    fontWeight: "500",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StageReview = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const stageReviewDetails = useSelector((state) => state.leadSource.stageReview);
  const [store, setStore] = useState([]);
  const [commonExpCenter, setExpCenter] = useState([]);
  const [storeDateFilter, setPivotDatefilters] = useState({
    startDate: "",
    endDate: "",
  });
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [showDetailedModal, setShowDetailedModal] = useState(false);
  const [csvData, setCsvData] = useState([]);
  const csvButtonRef = useRef(null);
  const [popMonthData, setPopMonthData] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectLost, setSeletLost] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const FIFTH_BUTTON_DISABLE_UNTIL_KEY = 'fifthButton_disableUntil';
  const [isDisabled, setIsDisabled] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isSpinning, setIsSpinning] = useState(false);
  const [selectedSearchType, setSelectedSearchType] = useState("");
  const searchTypes = [
    "Customer Name",
    "Email ID",
    "Lead No",
    "Project No",
    "Contact No",
    "Unique Lead No",
  ];

  useEffect(() => {
    expCenters();
    checkPivot('stageReview')
    setSelectedRole('ALL')
  }, []);

  const headers = [
    { key: "serialNo", label: "Sl. No." },
    { key: "projectCode", label: "Project No." },
    { key: "leadNumber", label: "Lead No." },
    { key: "clientName", label: "Client Name" },
    { key: "expCtrName", label: "Exp. Ctr Name" },
    { key: "currentStage", label: "Current Stage" },
    { key: "department", label: "Department" },
    { key: "leadCreatedDate", label: "Lead Created Date" },
    { key: "salesExecutive", label: "Sales Executive" },
    { key: "asm", label: "ASM" },
    { key: "callConnectedDate", label: "Call Connected Date" },
  ];

  const csvDownloadHandler = async (data) => {
    setLoading(true);
    try {
      let csvArray = [];
      for (let i = 0; i < popMonthData.length; i++) {
        let obj = {
            serialNo: i + 1,
            projectCode: popMonthData[i]?.erpProjectNo || "N/A",
            leadNumber: popMonthData[i]?.lead_no || "N/A",
            clientName: popMonthData[i]?.customerName || "N/A", // Corrected the optional chaining
            expCtrName: popMonthData[i]?.experienceCenterName || "N/A",
            currentStage: popMonthData[i]?.currentStage || "NA",
            department: popMonthData[i]?.departmentName || "NA",
            leadCreatedDate: moment(popMonthData[i]?.createdAt).format('DD-MM-YYYY') || "NA",
            salesExecutive: popMonthData[i]?.salesUserName || "NA",
            asm: popMonthData[i]?.assistantSalesManagerName || "NA",
            callConnectedDate: moment(popMonthData[i]?.callConnectedDate).format('DD-MM-YYYY') || "NA",
          };
          
        csvArray.push(obj);
        // obj = {
        //   serialNo: "",
        //   projectCode: "",
        //   clientName: "",
        //   totalValue: "",
        //   expCtrName: "",
        //   salesWonDate: "",
        //   internalDesignSignOffDate: "",
        //   designSignOffDate: "",
        //   materialDeliveryDate: "",
        //   actualCompletionDate: "",
        //   HoldRevocationDate: "",
        //   leadCreatedDate: "",
        //   salesExecutive: "",
        //   asm: ""
        // };
        // csvArray.push(obj);
      }
      setCsvData(csvArray);
      downloadExcel();
    } catch (error) {
      console.log("error", error);
      props?.setSnackInfo(
        error?.response?.data?.message ?? "Something went wrong",
        "error"
      );
    }
    setLoading(false);
  };

  const downloadExcel = () => {
    setLoading(true);
    try {
      setTimeout(() => {
        csvButtonRef.current.link.click();
      });
    } catch (err) {
      console.error(err.message);
    }
    setLoading(false);
  };

  const expCenterData = {};
  store.forEach((el) => {
      if (!expCenterData[el.experienceCenterName]) {
          expCenterData[el.experienceCenterName] = [];
      }
      expCenterData[el.experienceCenterName].push(el);
  });

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const stageReviewData = async (addExpCenter, usersData, selectedSearchType, searchInput) => {
    let expCenterData = addExpCenter?.map((el) => el._id);
    let users = "";
    if ((usersData?.users && usersData?.users.length !== 0) ||(selectedUsers && selectedUsers.length !== 0)) {
      users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id);
    }
    let obj = {
      startDate: storeDateFilter.startDate,
      endDate: storeDateFilter.endDate,
      selectedExperienceCenter: expCenterData ? expCenterData : "",
      tokenPercentage: selectedValue !== "" ? selectedValue : "",
      users: users ? users : "",
      userExpCenter: userDetails.experienceCenterId,
      lost: selectLost !== "" ? selectLost : "",
      pivotValue: "stageReview",
      searchType: selectedSearchType ? selectedSearchType : "",
      search: searchInput ? searchInput.toUpperCase() : "",
      selectedRole: 'ALL'
    };
    props.setLoading(true);
    props.setSnackInfo("Data Loading please wait...", "info");
    try {
      if(!stageReviewDetails || stageReviewDetails === null){
      let response = await HttpService.getStageReviewDataBasedOnExpCenter(obj);
      setStore(response.data.data);
      dispatch(setStageReview(response.data.data))
      }else{
        setStore(stageReviewDetails)
      }
    } catch (error) {
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const checkPivot = async (value) => {
    props.setLoading(true);
     if (value === 'stageReview') {
        stageReviewData();
        setSelectedExperienceCenter([]);
        setSelectedUsers([]);
        setSelectedRole("ALL")
        setSearchInput("")
        setSelectedSearchType("")
    } 
    props.setLoading(false);
}

  const formatNumberToTwoDecimalPlaces = (value) => {
    return parseFloat(value).toFixed(2);
  };

  const storePivotDate = (e) => {
    const { name, value } = e.target;
    setPivotDatefilters({ ...storeDateFilter, [name]: value });
  };
  const handlePivotDateFilter = () => {
    stageReviewData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleSearchType = (value) => {
    setSelectedSearchType(value);
    setSearchInput("");
  };

  const handleSearch = async (value) => {
    stageReviewData(
      selectedExperienceCenter,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && selectedSearchType && searchInput) {
      handleSearch(searchInput.toUpperCase());
    }
  };

  const handleMultipleExpData = (e, newvalue) => {
    setSelectedExperienceCenter(newvalue);
    handleExpData(newvalue);
  };

  const handleExpData = async (newvalue) => {
    props.setLoading(true);
    await stageReviewData(
      newvalue,
      selectedUsers,
      selectedSearchType,
      searchInput
    );
    props.setLoading(false);
  };

  const clearDateFilter = () => {
    setSearchInput("");
    setSelectedSearchType("");
    dispatch(setStageReview(null))
    setShouldRefresh(true) // Trigger the useEffect
    stageReviewData(selectedExperienceCenter, selectedUsers, "", "");
  };

  useEffect(() => {
    // Check if there's a stored disable time in localStorage
    const disableUntilTimestamp = localStorage.getItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
    
    if (disableUntilTimestamp) {
        const now = new Date().getTime();
        const disableUntil = parseInt(disableUntilTimestamp, 10);
        
        // If the disable time is in the future, calculate remaining time
        if (disableUntil > now) {
        const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
        setTimeLeft(remainingTimeInSeconds);
        setIsDisabled(true);
        } else {
        // If the time has passed, clear localStorage
        localStorage.removeItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
        setIsDisabled(false);
        setTimeLeft(0);
        }
    }
    
    // Set up timer to update remaining time
    let timer;
    if (isDisabled && timeLeft > 0) {
        timer = setInterval(() => {
        setTimeLeft(prevTime => {
            const newTime = prevTime - 1;
            if (newTime <= 0) {
            // When time is up, clear localStorage and enable button
            localStorage.removeItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY);
            setIsDisabled(false);
            return 0;
            }
            return newTime;
        });
        }, 1000);
    }
    
    return () => clearInterval(timer);
    }, [isDisabled, timeLeft]);

    useEffect(() => {
        if (shouldRefresh && stageReviewDetails === null) {
          stageReviewData(selectedExperienceCenter, selectedUsers, "", "");
            setShouldRefresh(false)
        }
    }, [stageReviewDetails, shouldRefresh])

    // Format time for display
    const formatTimeLeft = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

    // Replace your existing handleRefreshClick with this
    const handleRefreshClick = () => {
    // Calculate the timestamp 4 minutes from now
    const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
    
    // Store the timestamp in localStorage
    localStorage.setItem(FIFTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
    
    // Disable the button for 4 minutes
    setIsDisabled(true);
    setTimeLeft(10); // 4 minutes in seconds
    
    // Run the original functionality
    setIsSpinning(true);
    clearDateFilter();
    setTimeout(() => {
        setIsSpinning(false);
    }, 1000);
    };


  const dataBasedOnClick = async (data, text) => {
    props.setLoading(true);
    setShowDetailedModal(true);
    setPopMonthData(data);
    props.setLoading(false);
}
  
  const res = store?.find(item => item?.userName === "Total");

  return (
    <div className="App">
      {/* first table */}
      <div>
        <div>
          <Paper className={classes.paper}>
            <Grid
              container
              spacing={1}
              justifyContent="center"
              alignItems="center"
            >
              {userDetails.roles.find(role => role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesHead || role.name === ROLENAME.Admin || role.name === ROLENAME.CenterHead) &&
                <Grid item xs={12} sm={3}>
                    <FormControl style={{ width: "100%", marginTop: "0.4rem" }}>
                    <Autocomplete
                        multiple
                        value={selectedExperienceCenter}
                        onChange={handleMultipleExpData}
                        options={commonExpCenter}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Select Exp-Center"
                            variant="outlined"
                        />
                        )}
                    />
                    </FormControl>
                </Grid>
              }
        {/* {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.SalesUser) && */}
           <>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="startDate"
                  name="startDate"
                  label="Lead Created From Date"
                  type="date"
                  variant="outlined"
                  value={storeDateFilter.startDate}
                  onChange={storePivotDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <TextField
                  id="endDate"
                  name="endDate"
                  label="Lead Created End Date"
                  type="date"
                  variant="outlined"
                  value={storeDateFilter.endDate}
                  onChange={storePivotDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handlePivotDateFilter}
                    style={{
                      backgroundColor: "#F50057",
                      color: "#fff",
                      padding: "0.4rem 2rem",
                    }}
                    className={classes.submitButton}
                  >
                    Submit
                  </Button>
                  <Button
                    onClick={handleRefreshClick}
                    variant="contained"
                    disabled={isDisabled}
                    style={{ 
                      backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                      color: "#FFF2EB",
                      padding: "0.4rem 2rem",
                    }}
                  >
                    {isDisabled 
                      ? `Wait (${formatTimeLeft()})` 
                      : "Fetch New Data"}
                  </Button>
                </div>
              </Grid>
            </>
         {/* } */}
            </Grid>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                marginTop: "30px",
              }}
            >
              {/* Search Type Dropdown */}
              <TextField
                select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedSearchType}
                label="Search Type"
                name="searchType"
                onChange={(e) => handleSearchType(e.target.value)}
                variant="outlined"
                style={{ width: "30%", marginRight: "2%" }}
                size="small"
              >
                {searchTypes &&
                  searchTypes?.map((el, index) => (
                    <MenuItem key={index} value={el}>
                      {el}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Search Input */}
              <TextField
                label="Enter the input"
                name="searched"
                size="small"
                value={searchInput}
                onChange={(e) => {
                  setSearchInput(e.target.value);
                }}
                onKeyDown={handleKeyDown} // Listening for the "Enter" key press
                variant="outlined"
                style={{ width: "80%" }}
              />

              {/* Search Button */}
              <Button
                disabled={!selectedSearchType || !searchInput}
                variant="contained"
                color="primary"
                size="medium"
                style={{ alignSelf: "center", marginLeft: 20 }}
                className={classes.leadSearchButton}
                onClick={() => handleSearch(searchInput.toUpperCase())}
              >
                Search
              </Button>

              {/* Clear Filter Button */}
              <Button
                variant="contained"
                color="secondary"
                size="medium"
                style={{ marginLeft: 10 }}
                className={classes.leadClearButton}
                onClick={clearDateFilter}
              >
                Clear Filter
              </Button>
            </div>
          </Paper>
        </div>
        <br />
        <div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "30px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Left Pipeline Stages Review
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Lead Received from marketing and not called till now
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                     Call attended, requirement not collected
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Requirement collected, quotation not sent
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }} >Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }} >Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{fontWeight:'bold' }}>Count</StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalLeadReceivedData, "totalLeadReceived")}>{res?.totalLeadReceivedCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalPreSalesCallsData, "totalPreSalesCalls")}>{res?.totalPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.totalSalesCallsData, "totalSalesCalls")}>{res?.totalSalesCallsCount}</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are Set but no action taken </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionLeadReceivedData, "remSetNoActionLeadReceived")}>{res?.remSetNoActionLeadReceivedCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionPreSalesCallsData, "remSetNoActionPreSalesCalls")}>{res?.remSetNoActionPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remSetNoActionSalesCallsData, "remSetNoActionSalesCalls")}>{res?.remSetNoActionSalesCallsCount}</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are not Set </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetTotalLeadData, "remNotSetTotalLead")}>{res?.remNotSetTotalLeadCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetPreSalesCallsData, "remNotSetPreSalesCalls")}>{res?.remNotSetPreSalesCallsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.remNotSetSalesCallsData, "remNotSetSalesCalls")}>{res?.remNotSetSalesCallsCount}</StyledTableCell>

                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        {/* } */}
        </div>
      </div>
      {/* second table */}
        <div>
          <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "30px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Right Pipeline Stages Review (SE)
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Quotation Sent
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Site/Office visit
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold' }}
                    >
                      Negotiation
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>

                  </StyledTableRow>
                </TableHead>

                <TableHead
                  style={{ position: "sticky", top: 0, background: "white" }}
                >
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.qtSentTotalLeadsData, "qtSentTotalLeads")}>{res?.qtSentTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.siteVisitTotalLeadsData, "siteVisitTotalLeads")}>{res?.siteVisitTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.negotiationTotalLeadsData, "negotiationTotalLeads")}>{res?.negotiationTotalLeadsCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are Set but no action taken	by SE in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeQtSentData, "rmdSetNoActionSeQtSent")}>{res?.rmdSetNoActionSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeSiteVisitData, "rmdSetNoActionSeSiteVisit")}>{res?.rmdSetNoActionSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionSeNegotiationData, "rmdSetNoActionSeNegotiation")}>{res?.rmdSetNoActionSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Reminders are not Set	by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeQtSentData, "rmdNotSetSeQtSent")}>{res?.rmdNotSetSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeSiteVisitData, "rmdNotSetSeSiteVisit")}>{res?.rmdNotSetSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetSeNegotiationData, "rmdNotSetSeNegotiation")}>{res?.rmdNotSetSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of leads where notes are updated by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeQtSentData, "updatedNotesSeQtSent")}>{res?.updatedNotesSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeSiteVisitData, "updatedNotesSeSiteVisit")}>{res?.updatedNotesSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesSeNegotiationData, "updatedNotesSeNegotiation")}>{res?.updatedNotesSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of leads where notes are not updated by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeQtSentData, "notesNotUpdatedSeQtSent")}>{res?.notesNotUpdatedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeSiteVisitData, "notesNotUpdatedSeSiteVisit")}>{res?.notesNotUpdatedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedSeNegotiationData, "notesNotUpdatedSeNegotiation")}>{res?.notesNotUpdatedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are connected by SE in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeQtSentData, "callsConnectedSeQtSent")}>{res?.callsConnectedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeSiteVisitData, "callsConnectedSeSiteVisit")}>{res?.callsConnectedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedSeNegotiationData, "callsConnectedSeNegotiation")}>{res?.callsConnectedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are not connected by SE in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeQtSentData, "callsNotConnectedSeQtSent")}>{res?.callsNotConnectedSeQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeSiteVisitData, "callsNotConnectedSeSiteVisit")}>{res?.callsNotConnectedSeSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedSeNegotiationData, "callsNotConnectedSeNegotiation")}>{res?.callsNotConnectedSeNegotiationCount}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        {/*  } */}
        </div>
      {/* third table */}
      {userDetails.roles.find(role => role.name === ROLENAME.SalesManager || role.name === ROLENAME.AssistantSalesManager || role.name === ROLENAME.DGM_Sales || role.name === ROLENAME.Admin || role.name === ROLENAME.CenterHead || role.name === ROLENAME.SalesHead) &&
        <div style={{ maxHeight: "500px", overflow: "auto" }}>
            <TableContainer
              component={Paper}
              classes={{ root: classes.customTableContainer }}
              style={{ marginTop: "30px" }}
            >
              <Table style={{ minWidth: "600px" }}>
                <TableHead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: "white",
                  }}
                >
                  <StyledTableRow>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 9,
                        fontWeight:'bold',
                      }}
                      rowSpan={2}
                    >
                      Right Pipeline Stages Review (ASM)
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Quotation Sent
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Site/Office visit
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.bordercolors}
                      style={{ fontWeight:'bold'}}
                    >
                      Negotiation
                    </StyledTableCell>
                  </StyledTableRow>
                  {/* count value row */}
                  <StyledTableRow>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ fontWeight:'bold'}}>Count</StyledTableCell>
                  </StyledTableRow>
                </TableHead>

                <TableHead style={{ position: "sticky", top: 0, background: "white" }}>
                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>Total Leads</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.qtSentAsmTotalLeadsData, "qtSentAsmTotalLeads")}>{res?.qtSentAsmTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.siteVisitAsmTotalLeadsData, "siteVisitAsmTotalLeads")}>{res?.siteVisitAsmTotalLeadsCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.negotiationAsmTotalLeadsData, "negotiationAsmTotalLeads")}>{res?.negotiationAsmTotalLeadsCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>No. of Leads where Reminders are Set but no action taken	by ASM in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmQtSentData, "rmdSetNoActionAsmQtSent")}>{res?.rmdSetNoActionAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmSiteVisitData, "rmdSetNoActionAsmSiteVisit")}>{res?.rmdSetNoActionAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdSetNoActionAsmNegotiationData, "rmdSetNoActionAsmNegotiation")}>{res?.rmdSetNoActionAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}>  No. of Leads where Reminders are not Set	by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmQtSentData, "rmdNotSetAsmQtSent")}>{res?.rmdNotSetAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmSiteVisitData, "rmdNotSetAsmSiteVisit")}>{res?.rmdNotSetAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.rmdNotSetAsmNegotiationData, "rmdNotSetAsmNegotiation")}>{res?.rmdNotSetAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}> No. of leads where notes are updated by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmQtSentData, "updatedNotesAsmQtSent")}>{res?.updatedNotesAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmSiteVisitData, "updatedNotesAsmSiteVisit")}>{res?.updatedNotesAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.updatedNotesAsmNegotiationData, "updatedNotesAsmNegotiation")}>{res?.updatedNotesAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color:'black'}}> No. of leads where notes are not updated by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmQtSentData, "notesNotUpdatedAsmQtSent")}>{res?.notesNotUpdatedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmSiteVisitData, "notesNotUpdatedAsmSiteVisit")}>{res?.notesNotUpdatedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.notesNotUpdatedAsmNegotiationData, "notesNotUpdatedAsmNegotiation")}>{res?.notesNotUpdatedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are connected by ASM in last 2 days </StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmQtSentData, "callsConnectedAsmQtSent")}>{res?.callsConnectedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmSiteVisitData, "callsConnectedAsmSiteVisit")}>{res?.callsConnectedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsConnectedAsmNegotiationData, "callsConnectedAsmNegotiation")}>{res?.callsConnectedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>

                  <StyledTableRow>
                    <StyledTableCell style={{backgroundColor: 'white', color: 'black'}}> No. of Leads where Calls are not connected by ASM in last 2 days</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmQtSentData, "callsNotConnectedAsmQtSent")}>{res?.callsNotConnectedAsmQtSentCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmSiteVisitData, "callsNotConnectedAsmSiteVisit")}>{res?.callsNotConnectedAsmSiteVisitCount}</StyledTableCell>
                    <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", cursor: "pointer", color: "black", textDecoration: "underline", background: "white",}} onClick={(e) => dataBasedOnClick(res.callsNotConnectedAsmNegotiationData, "callsNotConnectedAsmNegotiation")}>{res?.callsNotConnectedAsmNegotiationCount}</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
              </Table>
            </TableContainer>
        </div>
      }

      <Modal
        title="Stage Review"
        centered
        visible={showDetailedModal}
        onCancel={() => setShowDetailedModal(false)}
        width={1000}
        maskClosable={true}
        footer={null}
      >
        <div className={classes.csv}>
          <CSVLink
            headers={headers}
            filename={`stageReviewData.csv`}
            data={csvData}
            ref={csvButtonRef}
          />
          <Button
            onClick={() => csvDownloadHandler(popMonthData)}
            style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
            variant="contained"
            color="secondary"
          >
            Download CSV
          </Button>
        </div>
        {popMonthData && (
          <TableContainer component={Paper} className={classes.table}>
            <Table
              style={{ width: 450 }}
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Sl. No.</StyledTableCell>
                  <StyledTableCell>Project No.</StyledTableCell>
                  <StyledTableCell>Lead No.</StyledTableCell>
                  <StyledTableCell>Client Name</StyledTableCell>
                  <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                  <StyledTableCell>Current Stage</StyledTableCell>
                  <StyledTableCell>Department</StyledTableCell>
                  <StyledTableCell>Lead Created Date</StyledTableCell>
                  <StyledTableCell>Sales Executive</StyledTableCell>
                  <StyledTableCell>ASM</StyledTableCell>
                  <StyledTableCell>Call Connected Date</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {popMonthData &&
                  popMonthData.map((data, i) => {
                    return (
                      <>
                        <StyledTableRow key={i}>
                          <StyledTableCell>{i + 1}</StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.erpProjectNo ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.erpProjectNo}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.lead_no ? (
                              <Link
                                to={`/project-logs/${data?._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  textAlign: "center",
                                }}
                              >
                                {data?.lead_no}
                              </Link>
                            ) : (
                              "NA"
                            )}
                          </StyledTableCell>
                          <StyledTableCell
                            component="th"
                            style={{ textAlign: "center" }}
                          >
                            {data?.customerName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.experienceCenterName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.currentStage}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.departmentName}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                           { moment(data?.createdAt).format('DD-MM-YYYY')}
                          </StyledTableCell>
                          <StyledTableCell component="th">
                            {data?.salesUserName ? data?.salesUserName : 'NA'}
                          </StyledTableCell>
                           <StyledTableCell component="th">
                             {data?.assistantSalesManagerName ? data?.assistantSalesManagerName: 'NA'}
                            </StyledTableCell>
                           <StyledTableCell component="th">
                             {data?.callConnectedDate ? moment(data?.callConnectedDate).format('DD-MM-YYYY') : 'NA'}
                            </StyledTableCell>
                        </StyledTableRow>
                      </>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Modal>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(StageReview);